import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2614 5.16798C18.5214 4.77698 18.4135 4.24899 18.0235 3.98899C17.6305 3.72999 17.1034 3.83697 16.8434 4.22797C15.2084 6.69197 15.2084 9.87597 16.8434 12.339C18.0994 14.233 18.0994 16.679 16.8434 18.571C16.5834 18.962 16.6914 19.49 17.0814 19.75C17.2264 19.846 17.3904 19.892 17.5514 19.892C17.8274 19.892 18.0974 19.758 18.2614 19.511C19.8954 17.048 19.8954 13.864 18.2614 11.399C17.0044 9.50796 17.0054 7.06198 18.2614 5.16798Z"
        fill="#A3A3A3"
      />
      <path
        d="M13.2028 5.16798C13.4628 4.77698 13.3548 4.24899 12.9648 3.98899C12.5718 3.72999 12.0448 3.83697 11.7848 4.22797C10.1498 6.69197 10.1498 9.87597 11.7848 12.339C13.0408 14.233 13.0408 16.679 11.7848 18.571C11.5248 18.962 11.6328 19.49 12.0228 19.75C12.1678 19.846 12.3318 19.892 12.4928 19.892C12.7688 19.892 13.0388 19.758 13.2028 19.511C14.8368 17.048 14.8368 13.864 13.2028 11.399C11.9458 9.50796 11.9468 7.06198 13.2028 5.16798Z"
        fill="#A3A3A3"
      />
      <path
        d="M8.13644 5.16798C8.39644 4.77698 8.28846 4.24899 7.89846 3.98899C7.50646 3.72999 6.97844 3.83697 6.71844 4.22797C5.08344 6.69197 5.08344 9.87597 6.71844 12.339C7.97444 14.233 7.97444 16.679 6.71844 18.571C6.45844 18.962 6.56644 19.49 6.95644 19.75C7.10144 19.846 7.26545 19.892 7.42645 19.892C7.70245 19.892 7.97244 19.758 8.13644 19.511C9.77044 17.048 9.77044 13.864 8.13644 11.399C6.87944 9.50796 6.88044 7.06198 8.13644 5.16798Z"
        fill="#A3A3A3"
      />
    </Svg>
  );
};

export default Icon;
